import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { selectToken } from "./authSlice";
import Cookies from "js-cookie";

const API_BASE_URL = process.env.REACT_APP_API_URL || "https://bookingserver.texascenterwellness.com/"

const getTokenFromCookies = () => {
  return Cookies.get("token");
};

export const routeQuestionApi = createApi({
  reducerPath: "routeQuestionApi",
  baseQuery: fetchBaseQuery({
    baseUrl: API_BASE_URL,
    prepareHeaders: (headers, { getState }) => {
      const token = selectToken(getState()) || getTokenFromCookies();
      if (token) {
        headers.set("Authorization", `${token}`);
      }
      return headers;
    },
  }),
  tagTypes: ["RouteData", "Calendar"],
  endpoints: (builder) => ({
    getVisitTypes: builder.query({
      query: (arg) => {
        const memberId =
          arg && typeof arg === "object" && arg.member_id != null
            ? arg.member_id
            : null;
        const qs = memberId ? `?member_id=${encodeURIComponent(memberId)}` : "";
        return `/GetVisitTypes${qs}`;
      },
      providesTags: ["RouteData"],
    }),

    getProviderConfig: builder.query({
      query: () => `/GetProviderConfig`,
      providesTags: ["RouteData"],
    }),
  
     getQuestionnaireData: builder.query({
      query: (visit_type_id) => `/GetQuestionnaire/${visit_type_id}`,
      providesTags: ["RouteData"],
    }),

        getMembersData: builder.query({
      query: (arg) => {
        const state =
          arg && typeof arg === "object" && arg.state != null
            ? arg.state
            : null;
        const qs = state ? `?state=${encodeURIComponent(state)}` : "";
        return `/GetMembers${qs}`;
      },
      providesTags: ["RouteData"],
    }),

    requestAssistance: builder.mutation({
      query: (body) => ({
        url: "/RequestAssistance",
        method: "POST",
        body,
      }),
    }),
  
    getCalendarAvailability: builder.query({
  query: ({ provider_id, from_date, to_date, visit_type }) =>
    `/GetCalendarAvailability/${encodeURIComponent(provider_id)}?from_date=${encodeURIComponent(from_date)}&to_date=${encodeURIComponent(to_date)}${visit_type ? `&visit_type=${encodeURIComponent(visit_type)}` : ''}`,
  providesTags: ["Calendar"],
}),

    createPatientData: builder.mutation({
      query: (Data) => ({
        url: "/CreatePatient",
        method: "POST",
        body: Data,
      }),
      // invalidatesTags: ["RouteData"],
    }),


     createSubmitQuestionnaire: builder.mutation({
      query: (Data) => ({
        url: "/SubmitQuestionnaire",
        method: "POST",
        body: Data,
      }),
      // invalidatesTags: ["RouteData"],
    }),


    createAppointment: builder.mutation({
      query: (Data) => ({
        url: "/CreateAppointment",
        method: "POST",
        body: Data,
      }),
      // invalidatesTags: ["RouteData"],
    }),

     createProcessAppointmentPayment: builder.mutation({
      query: (Data) => ({
        url: "/ProcessAppointmentPayment",
        method: "POST",
        body: Data,
      }),
      // invalidatesTags: ["RouteData"],
    }),
  }),
});


export const {
  useGetVisitTypesQuery,
  useGetProviderConfigQuery,
  useGetMembersDataQuery,
  useGetQuestionnaireDataQuery,
  useGetCalendarAvailabilityQuery,
  useCreatePatientDataMutation,
  useCreateAppointmentMutation,
  useCreateProcessAppointmentPaymentMutation,
  useCreateSubmitQuestionnaireMutation,
  useRequestAssistanceMutation,
} = routeQuestionApi;
